var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("el-table-column", {
    key: _vm.code,
    attrs: { label: _vm.name, "min-width": 200, fixed: false, align: "center" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (scope) {
          return [
            _c("ik-table-time", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.edit,
                  expression: "edit",
                },
              ],
              ref: "input_" + scope.$index + "_" + _vm.code,
              attrs: {
                line: scope.$index,
                code: _vm.code,
                name: _vm.name,
                "default-value": _vm.defaultValue,
                format: _vm.format,
                require: _vm.getRequire,
                rules: _vm.rules,
              },
              on: { onFieldChange: _vm.onFieldChange },
              model: {
                value: scope.row[_vm.code],
                callback: function ($$v) {
                  _vm.$set(scope.row, _vm.code, $$v)
                },
                expression: "scope.row[code]",
              },
            }),
            _c("ik-table-datetime-tag", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.edit,
                  expression: "!edit",
                },
              ],
              attrs: {
                value: scope.row[_vm.code],
                format: _vm.format,
                "error-sign": _vm.errorSign[scope.$index],
                message: _vm.message[scope.$index],
              },
            }),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }